import React from 'react'
import Link from '@material-ui/core/Link';
import { Paragraph } from '../../components/paragraph/Paragraph'
import certificate from './interpreting-certificate.pdf'

export function Interpreting() {
  return (
    <React.Fragment>
      <Paragraph>
        I am a qualified Public Service Interpreter, having achieved a Level 3 <Link href={certificate} target="_blank" rel="noopener">Certificate</Link> in Community Interpreting with the International School of Linguists, specialising in Social Care and Healthcare.
      </Paragraph>
      <Paragraph>
        I am well-versed in managing communication between multiple speakers; remaining impartial; carrying out sight translations of texts such as prescriptions and information leaflets; adopting the appropriate tone and register; adhering to relevant codes of conduct; researching the relevant terminology prior to appointments, and respecting confidentiality.
      </Paragraph>
      <Paragraph>
        I can provide consecutive interpreting services for telephone, video-call and face-to-face appointments. For a culturally sensitive, accurate and efficient interpreting service, don’t hesitate to contact me.
      </Paragraph>
    </React.Fragment>
  )
}
